<template>
  <Icon
    class="SupporterIcon"
    :name="iconName"
  />
</template>

<script lang="ts" setup>
import { SupporterType } from "@shared/lib/database/enum.types";
import { computed } from "vue";
import { IconName } from "./Icon.types";
import Icon from "./Icon.vue";

const {
  supporterType,
} = defineProps<{
  supporterType: SupporterType,
}>();

const iconName = computed(() => {
  switch (supporterType) {
    case "Believer":
      return IconName.star;
    case "Backer":
      return IconName.trophy;
    case "OfficialSponsor":
      return IconName.trophyWithStar;
    default:
      return IconName.heart;
  }
});
</script>
